"use strict";

import React from "react";
import ControlBarButton from "../ControlBarButton.jsx";

class ThemeChooser extends React.Component {
  _toggleTheme = (value) => {
    this.props.onThemeSelect(value);
  };

  render() {
    const { useCurrentTheme } = this.props;

    return (
      <div
        style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}
      >
        <span
          style={{
            color: "#777777",
            textTransform: "uppercase",
            fontWeight: 600,
            padding: 8,
            letterSpacing: "0.1em",
            fontSize: 12,
          }}
        >
          Import options:
        </span>
        <ControlBarButton
          icons=" "
          label="Apply My Fonts &amp; Colors"
          active={useCurrentTheme}
          onClick={this._toggleTheme.bind(this, true)}
        />
        <ControlBarButton
          icons=" "
          label="Use Original Design"
          active={!useCurrentTheme}
          onClick={this._toggleTheme.bind(this, false)}
        />
      </div>
    );
  }
}

export default ThemeChooser;
